// extracted by mini-css-extract-plugin
export var container = "_rs-0";
export var dotAnimation = "_rs-2";
export var dotsLoading = "_rs-1";